module.exports = __webpack_public_path__ + "static/media/home_anim.0f6b8241.webm";